import { dayjsCustom, transformDateFilter } from '@/shared/utils/helpers/datetime-format';

import type { TGetStatisticsParams, TStatsPeriod } from '../../store/types';

export const getStatsPeriodParams = (period: TStatsPeriod): TGetStatisticsParams => {
  const today = dayjsCustom();

  if (period === 'all') {
    return {};
  }

  if (period === 'yesterday') {
    const yesterday = today.subtract(1, 'day').format('YYYY-MM-DD');

    return {
      createdFrom: transformDateFilter(yesterday).dateFrom,
      createdTo: transformDateFilter(yesterday).dateTo,
    };
  }

  if (period === 'week') {
    const weekStart = today.subtract((today.day() + 6) % 7, 'day').format('YYYY-MM-DD');

    return {
      createdFrom: transformDateFilter(weekStart).dateFrom,
      createdTo: transformDateFilter(today.format('YYYY-MM-DD')).dateTo,
    };
  }

  if (period === 'month') {
    const monthStart = today.startOf('month').format('YYYY-MM-DD');

    return {
      createdFrom: transformDateFilter(monthStart).dateFrom,
      createdTo: transformDateFilter(today.format('YYYY-MM-DD')).dateTo,
    };
  }

  return {
    createdFrom: transformDateFilter(today.format('YYYY-MM-DD')).dateFrom,
    createdTo: transformDateFilter(today.format('YYYY-MM-DD')).dateTo,
  };
};
